export default "__VITE_ASSET__33X2cYYQ__"